import React from 'react'
import PropTypes from 'prop-types'
import ToggleButton from '../../../form/component/ToggleButton'


const ToggleProcessFlowButton = ({ isPartner, toggleProcessFlowVisibility, processFlowVisible }) => {
    if (isPartner) {
        return null
    }
    return (
        <span>
            <ToggleButton
                toggle={toggleProcessFlowVisibility}
                active={processFlowVisible}
                activeIcon="fa fa-search-minus"
                inactiveIcon="fa fa-search-plus"
            />&#160;
        </span>
    )
}

ToggleProcessFlowButton.propTypes = {
    isPartner: PropTypes.bool,
    toggleProcessFlowVisibility: PropTypes.func.isRequired,
    processFlowVisible: PropTypes.bool,
}

export default ToggleProcessFlowButton



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/ToggleProcessFlowButton.js